export default "__VITE_ASSET__D09rgm_Z__"